import { render } from "./MaterialAvatar.vue?vue&type=template&id=1db92942"
import script from "./MaterialAvatar.vue?vue&type=script&lang=js"
export * from "./MaterialAvatar.vue?vue&type=script&lang=js"

import "./MaterialAvatar.vue?vue&type=style&index=0&id=1db92942&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__